import { render, staticRenderFns } from "./observacion.vue?vue&type=template&id=644323df"
import script from "./observacion.vue?vue&type=script&lang=js"
export * from "./observacion.vue?vue&type=script&lang=js"
import style0 from "./observacion.vue?vue&type=style&index=0&id=644323df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports